import { useNavigate, useParams } from 'react-router-dom'

import {
  TrainingClassMaterialsDocument,
  TrainingClassMaterialsNewLinkModalDocument,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { NewLinkModal } from 'modules/trainings/components/NewLinkModal'

export default function TrainingClassMaterialsNewLinkModal() {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const session = useCurrentSession()
  const { id, classId } = useParams<{ id: string; classId: string }>()
  const [createTrainingClassLink] = useMutation(TrainingClassMaterialsNewLinkModalDocument, {
    extractorFn: (data) => data.trainingsMutations.createTrainingsTrainingClassLink,
    awaitRefetchQueries: true,
    refetchQueries: [TrainingClassMaterialsDocument],
  })

  return (
    <NewLinkModal
      description={i18n.t(
        'trainings.trainings_revamp.classes.materials.new_link_modal.description'
      )}
      title={i18n.t('trainings.trainings_revamp.classes.materials.new_link_modal.title')}
      onSubmit={async (data) => {
        const result = await createTrainingClassLink({
          variables: {
            trainingClassId: Number(classId),
            title: data.title,
            url: data.url,
            authorId: Number(session.employee?.id),
            companyId: session.company.id,
          },
        })
        const handled = handleResult(result, () => {
          app.setFlash({
            type: 'wrong',
            message: i18n.t(
              'trainings.trainings_revamp.classes.materials.new_link_modal.submit_error'
            ),
          })
        })
        if (handled.success) {
          navigate(
            navigation.trainings.list.details_revamp.view.trainingClasses.detail.materials.fullPath(
              { id: Number(id), classId: Number(classId) }
            )
          )
        }
      }}
      onClose={() => {
        navigate(
          navigation.trainings.list.details_revamp.view.trainingClasses.detail.materials.fullPath({
            id: Number(id),
            classId: Number(classId),
          })
        )
      }}
    />
  )
}
